import React, { useEffect, useState } from 'react';
import { useSpring, a } from '@react-spring/web';
import { ICarouselProp } from '../AllForCarousel';

export default function FlipCard(props: ICarouselProp) {
  const { images, config } = props;
  const { time, order } = config;
  const [flipped, set] = useState(false);
  const { transform, opacity } = useSpring({
    opacity: flipped ? 1 : 0,
    transform: `perspective(600px) rotateX(${flipped ? 180 : 0}deg)`,
    config: { mass: 5, tension: 500, friction: 80 }
  });

  const [img1, setImg1] = useState(images[0]);
  const [img2, setImg2] = useState(images[1] || '');
  useEffect(() => {
    let currentIndex = 2;
    const timer = setInterval(() => {
      // images.slice(0,2)
      // if(currentIndex % 2){
      //     setImg2(images[currentIndex])
      // }else{
      //     setImg1(images[currentIndex])
      // }
      set(state => !state);
      currentIndex++;
    }, time);
    return () => clearInterval(timer);
  }, [time, images]);
  return (
    <div
      className={'component-carousel flip-card'}
      onClick={() => set(state => !state)}
    >
      <a.div
        className={`c back`}
        style={{
          opacity: opacity.to(o => 1 - o),
          transform,
          backgroundImage: `url(${img1})`
        }}
      />
      <a.div
        className={`c front`}
        style={{
          opacity,
          transform,
          rotateX: '180deg',
          backgroundImage: `url(${img2})`
        }}
      />
    </div>
  );
}
